import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const RoomCard = ({src, title, description}) => {
  const classes = useStyles();

	return (
  <div className={classes.root}>
    <figure className={classes.imageWrapper}>
      <img className={classes.media} src={src} alt={title} />
    </figure>

    <Typography color="textPrimary" variant="h5">{title}</Typography>
    <Typography color="textSecondary" variant="h6">{description}</Typography>
    
  </div>
);
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(4,2,2,2),
    [theme.breakpoints.down("xs")]: {
      "& h6": {
        wordWrap: "break-word",
      },
    },
  },
  imageWrapper: {
    overflow: "hidden",
  },
  media: {
    height: "400px",
    width: "600px",
    objectFit: "cover",
    transform: "scale(1.05)",
    webkitTransform: "scale(1.05)",
    transition: ".4s ease-in-out",
    webkitTransition: ".4s ease-in-out",
    "&:hover": {
      transform:"scale(1)",
      webkitTransform: "scale(1)",
    },
    [theme.breakpoints.down("xs")]: {
      height: "200px",
      width:"300px"
    } 
  },
}));

export default RoomCard